import { render, staticRenderFns } from "./ManuscriptPreview.vue?vue&type=template&id=0e55b40d&scoped=true&"
import script from "./ManuscriptPreview.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptPreview.vue?vue&type=style&index=0&id=0e55b40d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e55b40d",
  null
  
)

export default component.exports